import React from "react";
import MyOrderItem from "../Shopping/MyOrderItem"
import test from "../../../assets/img/event_poster.png"


function OrderExchangeDetail(){

  return(
    <div className="my_table mt_48">
      {/* 판매 교환 상세페이지 */}

      {/* 교환상품 정보 */}
      <div className="my_container order_detail_form">
        <div className="order_title">
          <h3>교환상품 정보</h3> 
        </div>
          {/* 판매쪽 MyOrderItem UI는 판매상세페이지 종류에 따라 다릅니다.  */}
          {/* 주문번호 밑줄, 화살표 제거해주세요 */}
          {/* 뱃지 : 교환신청 / 교환완료 / 구매확정 */}
          {/* 버튼 : 경우에 따라 교환철회(중간) / 구매확정(우측) 표출 */}
          <MyOrderItem type="sale"/>
          <div className="py-16 flex-4 column reason_box">
            <p className="text_small_b">교환사유 : 단순변심 / 회수방법: 회수신청</p>
            <p className="text_small_b g-80">생각했던 느낌이 아니었고, 착용이 불편했습니다 빠른 교환 처리 요청드립니다.</p>

            {/* 오배송, 상품상이, 상품불량 일 경우 : 상품 교환 사유 이미지 존재시 출력 */}
            <div className="img_attach_box">
              <ul className="preview_list">
                <li className="default_btn ic_lg">
                  <img
                    className="object-cover"
                    src={test}
                    alt="이미지 첨부"
                    loading="lazy"
                  />
                </li>
                <li className="default_btn ic_lg">
                  <img
                    className="object-cover"
                    src={test}
                    alt="이미지 첨부"
                    loading="lazy"
                  />
                </li>
                <li className="default_btn ic_lg">
                  <img
                    className="object-cover"
                    src={test}
                    alt="이미지 첨부"
                    loading="lazy"
                  />
                </li>
              </ul>
            </div>
          </div>
      </div>

      {/* 교환 정보 */}
      <div className="my_container order_detail_form">
        <div className="order_title">
          <h3>교환 정보</h3>
        </div>
        <ul className="default_info_table v2">
          <li className="info_item">
            <div className="label label_start">
              <span>환불금액</span>
            </div>
            <div className="form_info payment_info">
              <div className="info_detail flex-8 column">
                <p className="price">
                  3,000
                  <i className="won xl">원</i>
                </p>
                <div className="text_small_b g-80 flex-4 column">
                  <div className="flex-center-4">
                    교환 배송비: 2,000원
                  </div>
                  <div className="flex-center-4">
                    옵션 변경비: 1,000원
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      {/* 수거지 정보 */}
      <div className="my_container order_detail_form estimate_detail">
          <div className="order_title">
            <h3>수거지 정보</h3> 
          </div>
          <ul className="default_info_table v2 addr_table">
            <li className="info_item">
              <div className="label label_start">
                <span>성명</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  강승혜
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label label_start">
                <span>휴대폰 번호</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  010-1234-5678
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label label_start">
                <span>주소</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  [16824] 경기도 고양시 덕양사 덕은동 519-87, 덕은리버워크 A동 1713호
                </div>
              </div>
            </li>
          </ul>
        </div>

      {/* 목록 버튼 */}
      <div className="submit_box">
        <button
          className="default_btn white lg"
          >목록
        </button>
      </div>
    </div>
  )
};

export default OrderExchangeDetail;